import { LiveChatService } from './../../services/live-chat.service';
/* eslint-disable @typescript-eslint/naming-convention */
import { Component, Input, Output, EventEmitter, ViewEncapsulation, HostBinding, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ButtonType } from '@/shared/interfaces/button.interface';
import { IconWeight } from '@/shared/interfaces/icon-weight.enum';
import { AnalyticsService } from '@/shared/services';

@Component({
  selector: 'vm-confirmation',
  templateUrl: './confirmation.component.html',
  styleUrls: ['./confirmation.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class ConfirmationComponent implements OnInit {
  ButtonType = ButtonType;

  @Input() icon?: any;
  @Input() iconColor?: any;
  @Input() iconWeight: IconWeight;
  @Input() iconSrc?: any;
  @Input() iconSrcWidth? = '64px';
  @Input() iconSrcHeight? = '64px';
  @Input() secondaryModalType?: any;
  @Input() title?: any;
  @Input() subtitle?: any;
  @Input() info?: any;
  @Input() nextActions?: any;
  @Input() extraInfo?: string;
  @Input() secondaryModalLabel = '';
  @Input() secondaryModalCopy? = '';
  @Input() tertiaryModalTitle?: string;
  @Input() tertiaryModalLabel?: string;
  @Input() tertiaryModalCopy?: string;
  @Input() chatbotId = 'faultsbuttonnew';
  @Input() tiles? = [];
  @Input() ctaContentTypeTitle: string;
  @Input() alignLeft: boolean;
  @Output() next = new EventEmitter();
  @Output() secondaryModalOpened = new EventEmitter();
  @Output() tertiaryModalOpened = new EventEmitter();

  IconWeight = IconWeight;

  nextAction: {
    id?: string;
    uid?: string;
    url?: string;
  };
  isSecondaryModalOpen = false;
  isTertiaryModalOpen = false;
  modalType: any;
  strapiUrl = '';
  @HostBinding('class.confirmation') containerClass = true;

  private trackingTargetLabels = ['Yes', 'No'];
  private trackingIgnoredPages = ['identified', 'cancel', 'cancel-confirmation', 'next', 'lights', 'results'];

  constructor(
    public liveChatService: LiveChatService,
    private router: Router,
    private analyticsService: AnalyticsService
  ) {}

  ngOnInit(): void {
    setTimeout(() => {
      this.liveChatService.reloadLiveAgentMonitor();
    }, 500);
  }

  onNext(e: any, id: string, uid?: string, url?: string) {
    this.trackContentClick(e);
    this.nextAction = {
      id,
      uid,
      url,
    };
    this.next.emit(this.nextAction);
  }

  onRoute(e: any, url: string) {
    this.trackContentClick(e);
    this.router.navigateByUrl(url);
  }

  onNextTertiary(action: any, e: any) {
    this.trackContentClick(e);
    e.preventDefault();
    this.onNext(e, action.id, action.uid, action.url);
    return false;
  }

  openChat(e: any) {
    this.analyticsService.trackLiveChatEvent(this.chatbotId);
    e.preventDefault();
    return false;
  }

  openSecondaryModal(e: any): boolean {
    e.preventDefault();
    this.isSecondaryModalOpen = true;
    this.secondaryModalOpened.emit();
    return false;
  }

  closeSecondaryModal(e: any): boolean {
    this.isSecondaryModalOpen = false;
    return false;
  }

  openTertiaryModal(e: any): boolean {
    this.trackContentClick(e, 'modal');
    e.preventDefault();
    this.isTertiaryModalOpen = true;
    this.tertiaryModalOpened.emit();
    return false;
  }

  protected trackContentClick(e: any, type = null) {
    const elementLabel = e?.srcElement?.innerText || e?.title || '';
    const contentType = this.ctaContentTypeTitle || 'web - faults - alternative support options';
    const contentLink = window.location.href.split('?')[0];
    const contentName = type || elementLabel;
    const isTargetPage = this.trackingIgnoredPages.some((page) => contentLink?.endsWith(page) === false);
    const isTargetEvent = this.trackingTargetLabels.some((label) => elementLabel?.toString()?.startsWith(label));
    if (isTargetEvent && isTargetPage) {
      this.analyticsService.trackCustomerFeedbackEvent(elementLabel);
    } else {
      const eventParams = {
        content_type: contentType,
        content_text: elementLabel,
        content_link: contentLink,
        content_name: contentName,
      };
      this.analyticsService.addContentClickedToDataLayer(eventParams);
    }
  }

  // TODO: Temp until Chat is back.
  getChatButtonDecoration(actions, label, buttonStyle) {
    if (actions && label === 'Call us') {
      const buttons = actions.filter((b) => b?.type !== ButtonType.URL);
      if (buttons?.length === 1) {
        return 'outline';
      }
    }
    return buttonStyle;
  }
}
